import React from 'react';
import PropTypes from 'prop-types';
import onyxLogo from '../../assets/brand/onyx-logo.svg';
import onyxLogoDark from '../../assets/brand/onyx-logo-dark.svg';
import { useThemeMode } from '../../providers/ThemeModeProvider';

/**
 * Official Onyx geometric mark (+ optional Agate Recut wordmark).
 * Light / dark icons from Figma Assets (471:13683 / 471:13687).
 * Wordmark color follows --color-text via theme.
 */
export function OnyxBrandMark({
  size = 28,
  withWordmark = false,
  className = '',
  /** Force light|dark mark; default follows ThemeModeProvider / data-theme */
  tone,
}) {
  const { mode } = useThemeMode();
  const effectiveTone = tone === 'light' || tone === 'dark' ? tone : mode;
  const src = effectiveTone === 'dark' ? onyxLogoDark : onyxLogo;

  return (
    <span
      className={[
        'onyx-brand',
        withWordmark ? 'onyx-brand--wordmark' : '',
        `onyx-brand--${effectiveTone}`,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      data-testid="onyx-brand-mark"
      data-tone={effectiveTone}
    >
      <img
        src={src}
        alt=""
        height={size}
        className="onyx-brand-mark"
        draggable={false}
      />
      {withWordmark ? (
        <span className="onyx-brand-wordmark" aria-label="Onyx">
          Onyx
        </span>
      ) : null}
    </span>
  );
}

OnyxBrandMark.propTypes = {
  size: PropTypes.number,
  withWordmark: PropTypes.bool,
  className: PropTypes.string,
  tone: PropTypes.oneOf(['light', 'dark']),
};

export default OnyxBrandMark;
